import React from "react";

const InfoBox = ({ fName, jobTitle, company, black, textAlign = "none" }) => {
  return (
    <div
      style={{
        color: black ? "black" : "white",
        textAlign: textAlign,
      }}
    >
      <p
        style={{
          fontWeight: "500",
          fontSize: "22px",
          wordBreak: "break-all",
        }}
      >
        {fName}
      </p>
      {jobTitle && (
        <p
          style={{
            fontSize: "16px",
            fontWeight: "500",
            wordBreak: "break-all",
          }}
        >
          {jobTitle}
        </p>
      )}
      {company && (
        <p
          style={{
            fontSize: "16px",
            fontWeight: "500",
            wordBreak: "break-all",
          }}
        >
          {company}
        </p>
      )}
    </div>
  );
};

export default InfoBox;
